module.exports = __webpack_public_path__ + "img/20_107.2e09d236.png";